export default __webpack_public_path__ + "assets/reso_icon.svg";